<template>
	<div class="works">
		<modelReward :Reward="Reward" :adminReward="adminReward"></modelReward>
		<loginheader flagg="1" num="4"></loginheader>
		<div class="works-bg">
			<img :src="info.detail_pic" alt class="works-img" />
		</div>
		<div class="works-concent">
			<div class="works-con">
				<div class="works-con-left">
					<div class="works-con-left-head">
						<img
							:src="info.cover_pic?info.cover_pic:'../../img/001.png'"
							alt
							class="works-con-left-head-left"
						/>
						<div class="works-con-left-head-right">
							<div class="works-right">
								<div>3章</div>
								<span>每日更新</span>
							</div>
							<p class="works-myp">{{info.title}}</p>
							<div class="works-mydiv">
								<p class="works-myp1" v-for="(item, index) in info.bookcate" :key="index">{{item}}</p>
							</div>
							<p class="works-myp3">
								更新时间{{episodes[episodes.length-1].create_time_text}}
								<span style="margin-left:18px">每日12点、17点、22点更新</span>
							</p>
							<div class="readnum">
								<div class="works-myp2">
									<span style="font-size:20px">{{info.wordnumber}}</span> 字
								</div>
								<div class="readnum1"></div>
								<div class="works-myp2">
									<span style="font-size:20px">{{info.reader}}</span> 阅读数
								</div>
								<div class="readnum1"></div>
								<div class="works-myp2">
									<span style="font-size:20px">{{info.collect}}</span> 订阅数
								</div>
							</div>
							<p class="works-myp4" v-if="info.status==1">连载中</p>
							<p class="works-myp4" v-if="info.status==2">已完成</p>
							<div class="works-mydiv1">
								<button type="button" class="works-btn" @click="toRead(episodes[0].id,0)">开始阅读</button>
								<Collection type="book" :id="this.$route.query.id" :state="books.collect"></Collection>
								<!-- <button type="button" class="works-btn2" @click="reward()">打赏作者</button> -->
							</div>
						</div>
					</div>
					 <div>
					<a href="https://weibo.com/3390288124/I88pwm2RM" target="_blank">
						<img src="../../img/weibo_ad.jpg" width="100%" style="margin-top:10px;" />
					</a>
					</div>
					<div>
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane label="作品信息" name="first">
								<div class="works-xxk-div">
									<p class="works-xxk-div-p">简介:</p>
									<p class="works-xxk-div-p1">{{info.summary}}</p>
									<p class="works-xxk-div-p2">最近更新:</p>
									<div class="works-xxk-div-div">
										<div class="works-xxk-div-div-div" v-for="(item, index) in episodes" :key="index">
											<p class="works-xxk-div-p3" @click="toRead(item.id,index)">{{item.title}}</p>
											<p class="works-xxk-div-p4">{{item.update_time_text}}</p>
										</div>
									</div>
								</div>
								<publiclogin></publiclogin>
								<Comment :comment="comment" :reportid="info.id" type="book"></Comment>
							</el-tab-pane>
							<el-tab-pane :label="'目录('+episodes.length+'章)'" name="second">
								<publicmulu :episodes="episodes"></publicmulu>
							</el-tab-pane>
							<el-tab-pane label="讨论" name="third">
								<publiclogin></publiclogin>
								<Comment :comment="comment" :reportid="info.id" type="book"></Comment>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<div class="works-con-right">
					<div class="works-con-right-head">
						<img src="../../img/sy.png" alt class="portrait" />
						<p class="works-Nickname">{{info.author}}</p>
						<p class="works-autograph">{{info.publish_bio}}</p>
						<!--
						<div class="mybtnbox">
							<follow :follow="follow" :id="info.publish"></follow>
						</div>
						-->
					</div>
					<!-- <div class="works-con-right-cen">
						<img :src="advert" alt class="works-con-right-cen-img" />
						<p class="advert">广告</p>
					</div>-->
					<div class="works-con-right-foot">
						<p>其他推荐</p>
						<div class="tuijian-div" v-for="(item, index) in recomCartoon" :key="index">
							<p class="works-con-right-foot-p1">[{{item.bookcate[0]}}]</p>
							<p class="works-con-right-foot-p2" @click="toWorks(item.id)">{{item.title}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 回到顶部 -->
		<Backtop></Backtop>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Fotter from "../Fotter.vue";
	import loginheader from "../loginheader.vue";
	import Comment from "../Comment.vue";
	import publiclogin from "../publiclogin.vue";
	import Backtop from "../Backtop.vue";
	import modelReward from "../modelReward.vue";
	import publicmulu from "../publicmulu.vue";
	import Collection from "../Collection.vue";
	import follow from "../follow.vue";
	export default {
		name: "App",
		components: {
			Fotter,
			loginheader,
			Comment,
			Backtop,
			modelReward,
			publicmulu,
			publiclogin,
			Collection,
			follow
		},
		data() {
			return {
				activeName: "first",
				g: "0",
				Reward: false,
				show: true,
				books: {},
				comment: "",
				info: "",
				recomCartoon: "",
				id: "",
				episodes: "",
				redLogID: "",
				adminReward: "",
				advert: "",
				follow: ""
			};
		},
		methods: {
			handleClick(tab, event) {},
			reward() {
				this.Reward = !this.Reward;
				var adminReward = {
					token: "",
					money: "",
					ouid: this.info.publish
				};
				this.adminReward = adminReward;
			},
			toRead(ji_no, index) {
				const toRead = this.$router.resolve({
					name: "detailss",
					query: { id: this.$route.query.id, index: index, ji_no: ji_no }
				});
				window.open(toRead.href, "_blank");
			},
			getinfo() {
				this.$http
					.get(
						"book/info/" +
							this.$route.query.id +
							"?token=" +
							this.$cookies.get("token")
					)
					.then(res => {
						this.books = res.body.data;
						this.info = res.body.data.info;
						this.follow = res.body.data.follow;
						this.recomCartoon = res.body.data.recomCartoon;
						this.id = this.$route.query.id;
					});
			},
			getFpage(page = 1, size = 5) {
				this.$http
					.get(
						`comment/show/book/${this.$route.query.id}?page=${page}&size=${size}`
					)
					.then(res => {
						this.comment = res.body.msg;
					});
			},
			getCpage(page = 1, size = 5, child = 1, childSize = 5) {
				this.$http
					.get(
						`comment/show/book/${this.$route.query.id}/page/${page}/size/${size}/child/${child}/childSize/${childSize}`
					)
					.then(res => {
						this.comment = res.body.msg;
					});
			},
			toWorks(id) {
				const InfoDetail = this.$router.resolve({
					path: "/works",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			},
			getcomment() {
				this.$http
					.get(`comment/show/book/${this.$route.query.id}?page=1&size=5`)
					.then(res => {
						this.comment = res.body.msg;
					});
			}
		},
		created() {
			// console.log(this);
			this.getinfo();
			this.getCpage();
			this.$http.get("book/dir/" + this.$route.query.id).then(res => {
				this.episodes = res.body.data.episodes;
				this.redLogID = res.body.data.redLogID;
			});
			this.$http.get("index").then(res => {
				if (res.body.data.advert.length > 1) {
					this.advert = res.body.data.advert[2].image;
				}
			});
		}
	};
</script>
<style>
	/* 选项卡 */
	.el-tabs__nav-scroll {
		display: flex;
		justify-content: center;
		margin-top: 40px !important;
		color: #28a3b1 !important;
	}

	.el-tabs__item {
		color: #cccccc;
		font-size: 18px !important;
	}

	.el-tabs__item:hover {
		color: #28a3b1;
	}

	.el-tabs__active-bar {
		background-color: #28a3b1 !important;
	}

	.el-tabs__item.is-active {
		color: #28a3b1;
	}
	.works {
		background-color: #f5f5f5;
	}
	.works-xxk-div {
		padding: 30px 0;
		box-sizing: border-box;
	}

	.works-xxk-div-p {
		font-size: 16px;
		color: #212121;
		font-weight: bold;
	}

	.works-xxk-div-p1 {
		margin-top: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 6;
		overflow: hidden;
		font-size: 14px;
	}

	.works-xxk-div-p2 {
		font-size: 16px;
		margin-top: 30px;
		font-weight: bold;
	}

	.works-xxk-div-div {
		display: flex;
		margin-top: 16px;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.works-xxk-div-div-div {
		display: flex;
	}

	.works-xxk-div-p3 {
		font-size: 14px;
		margin-right: 10px;
		cursor: pointer;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 9.5em;
	}

	.works-xxk-div-p4 {
		color: #808080;
		font-size: 12px;
	}

	.works-xxk-mydiv {
		display: flex;
		margin-top: 16px;
	}

	.works-xxk-mydiv-p {
		font-size: 14px;
		color: #28a3b1;
	}

	.works-xxk-mydiv-p1 {
		font-size: 14px;
	}
</style>
<style scoped="scoped">
	.works-right {
		position: absolute;
		top: 40px;
		right: 40px;
		width: 80px;
		text-align: center;
	}
	.works-right div {
		font-size: 40px;
		margin-bottom: 12px;
		line-height: 40px;
	}
	.works-right > span {
		font-size: 14px !important;
		color: #808080;
		line-height: 14px;
	}
	.works {
		position: relative;
	}

	.works-bg {
		width: 100%;
		height: 300px;
		position: absolute;
		top: 40px;
	}

	.works-img {
		width: 100%;
		height: 300px;
	}

	.works-concent {
		margin-top: 220px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.works-con {
		width: 1200px;
		height: auto;
		z-index: 100;
		display: flex;
		margin-bottom: 40px;
	}

	.works-con-left {
		width: 920px;

		border-radius: 8px;
		margin-right: 40px;
	}

	.works-con-left-head {
		width: 920px;
		height: 320px;
		border-radius: 8px;
		background-color: #fff;
		padding: 24px;
		display: flex;
		border: 1px solid #cccccc;
		box-sizing: border-box;
		position: relative;
	}

	.works-con-left-head-left {
		width: 160px;
		height: 220px;
		margin-right: 24px;
		border-radius: 6px;
	}

	.works-myp {
		font-size: 30px;
		color: #212121;
		font-weight: bold;
	}

	.works-mydiv {
		margin-top: 16px;
		display: flex;
	}

	.works-myp1 {
		padding: 3px 10px;
		border: 1px solid #808080;
		margin-right: 10px;
		font-size: 12px;
		border-radius: 13px;
		color: #808080;
		height: 16px;
		line-height: 16px;
	}

	.works-myp2 {
		font-size: 14px;
		margin-top: 10px;
	}
	.readnum {
		display: flex;
		flex-direction: row;
	}
	.readnum1 {
		width: 2px;
		height: 16px;
		background: rgba(217, 217, 217, 1);
		position: relative;
		bottom: -16px;
		margin: 0 16px;
	}
	.works-myp3 {
		margin-top: 20px;
		font-size: 14px;
		color: #212121;
	}

	.works-myp4 {
		margin-top: 10px;
		font-size: 14px;
		color: #d52e25;
	}

	.works-mydiv1 {
		display: flex;
		margin-top: 40px;
	}

	.works-btn {
		width: 120px;
		height: 40px;
		border: 0;
		border-radius: 6px;
		background-color: #d52e25;
		color: #fff;
		margin-right: 16px;
	}

	.works-btn2 {
		width: 120px;
		height: 40px;
		border: 0;
		border-radius: 6px;
		background-color: #28a3b1;
		color: #fff;
		margin-right: 16px;
	}

	.works-con-right-head {
		width: 240px;
		height: 188px;
		background-color: #ffffff;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		border-radius: 8px;
		padding: 20px;
	}

	.portrait {
		width: 60px;
		height: 60px;
		margin: 0 auto;
		border-radius: 50%;
	}

	.works-Nickname {
		font-size: 16px;
		width: 107px;
		margin: 16px auto 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}

	.works-autograph {
		width: 150px;
		font-size: 12px;
		margin: 0 auto;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-align: center;
	}

	.mybtnbox {
		display: flex;
		justify-content: center;
	}

	.follow {
		width: 80px;
		height: 32px;
		border: 0;
		border-radius: 4px;
		background-color: #28a3b1;
		color: #fff;
		font-size: 14px;
		margin: 30px auto 0;
	}
	.follow1 {
		width: 80px;
		height: 32px;
		border: 0;
		border-radius: 4px;
		background-color: #b3b3b3;
		color: #fff;
		font-size: 14px;
		margin: 30px auto 0;
	}
	.works-con-right-cen-img {
		width: 240px;
		height: 300px;
	}
	.works-con-right-cen {
		width: 240px;
		height: 300px;
		margin-top: 10px;
		position: relative;
	}
	.advert {
		width: 34px;
		height: 16px;
		background: #b3b3b3;
		text-align: center;
		color: #fff;
		font-size: 12px;
		position: absolute;
		bottom: 12px;
		right: 12px;
	}
	.works-con-right-foot {
		width: 240px;
		height: 310px;
		border-radius: 8px;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		margin-top: 10px;
		padding: 12px;
	}
	.works-con-right-foot-p {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 20px;
	}
	.tuijian-div {
		display: flex;
		margin-bottom: 5px;
		margin-top: 8px;
	}
	.works-con-right-foot-p1 {
		font-size: 14px;
		margin-right: 12px;
	}
	.works-con-right-foot-p2 {
		font-size: 14px;
		width: 135px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/Novel/works.vue